import React from 'react';

interface DoNotStripSpacesSpanProps {
  title: string;
  cypressId: string;
}

const DoNotStripSpacesSpan = React.forwardRef<HTMLSpanElement, DoNotStripSpacesSpanProps>(
  ({ cypressId, title, ...props }, ref) => {
    return (
      <span ref={ref} style={{ whiteSpace: 'pre-wrap' }} data-cy={cypressId} {...props}>
        {title}
      </span>
    );
  }
);

DoNotStripSpacesSpan.displayName = 'DoNotStripSpacesSpan';

export default DoNotStripSpacesSpan;
